<template>
	<div id="publish-apply-index" class="publish-apply-index issue_apply p_background clearfix">
		<h3 id="issue_title" class="all_title">发布应用</h3>

		<el-steps class="publish-steps" :active="active" finish-status="success" simple style="margin-bottom: 20px;">
		  <el-step title="部署类型" />
		  <el-step title="基本信息" />
		  <el-step title="扩展信息" />
		  <el-step title="图片信息" />
		  <el-step title="资费信息" />
		  <el-step title="发布" />
		</el-steps>

		<keep-alive>
			<compontent :is="currentView" :data="datas" ref="children" :style="{ 'min-height': height + 'px' }"/>
		</keep-alive>

		<section class="footer text-right line_block">
			<!--<span class="color_9">内容已于 2016年12月2日 14:37分自动保存</span>-->
			<button class="btn btn_text publish-btn-text" @click="$router.push({path: '/all_app'})">返回</button>
			<span class="btn btn_submit" :disabled="active === 0" @click="saveTemporary()">保存</span>
			<button class="btn btn_submit" v-if="!hidsub" v-show="active === 5" @click="save()">提交审核</button>
			<button class="btn btn_submit" v-show="active != 5" @click="next">下一步</button>
			<button class="btn btn_text publish-btn-text" :class="{ 'is-disabled': active === 0 }" :disabled="active === 0" @click="prev">上一步</button>
		</section>
	</div>
</template>

<script>
import { on, off, winSize } from '../../assets/js/dom'
import vDeploy from './module/deploy'						//部署类型
import vBase from './module/base'								//基础信息
import vExtInfo from './module/ext_info'					//扩展信息
import vPhotoInfo from './module/photo_info'			//图片信息
import vExpInfo from './module/exp_info'			//资费信息
import vPublish from './module/publish'			//发布
import { MessageBox } from 'element-ui'
	export default {
		data() {
			return {
				datas: {},
				active: 0,
				currentView: 'vDeploy',
				height: winSize().height - 265,
				backRouter: '',
				resizeTimer: null,//
				formData:'',
				//应用id
			    appId : this.$route.params.appid,
			    appVersionId:this.$route.params.appVersionId,
			    versioncontent: this.$route.params.versioncontent,
			    inspertStatus: this.$route.params.inspertStatus,
			    appVersionList: [],
			    appFiles:[],
			    hid: false,
				hidsub: false,
				hidsubv: false,
				priceList:[],
				tCloudApp: {
					id: '',
					appName: '',
					appEnName: '',
					appType: '',
					businessType: '',
					deployType: '',
					appClinetid: '',
					appClinetsercet: '',
					appversionid: '',
					uploadUser: '',
					specialType: '',
					delFlag: '',
					authCode: '',
					authType: '',
					inputTime: '',
					inputUser: '',
					updateTime: '',
					updateUser: '',
					viewName: '',
					freeType: '', //免费试用类型
					appLevel: '', //应用级别
				},
				tCloudAppVersion: {
					id: '',
					appid: '',
					versionNo: '',
					appComment: '',
					appInstallpackagePath: '',
					versionComment: '',
					publishTime: '',
					misdataApis: '',
					addserviceApis: '',
					visitUrl: '',
					userScope: '',
					inspectStatus: '',
					publishStatus: '',
					delFlag: '',
					inputTime: '',
					inputUser: '',
					updateTime: '',
					updateUser: '',
					publishType: '',
					appVersionIconFilePath: '',
					appVersionApplyFilePath: '',
					openType: '1',
					windowWidth: '700',
					windowHeight: '500',
					clientType: '',
					packageName:''
				},
      }
		},

		components: {
			vBase,
			vExtInfo,
			vPhotoInfo,
			vDeploy,
			vExpInfo,
			vPublish
		},

		beforeRouteEnter(to, form, next) {
			next(vm => {
				vm.backRouter = form.fullPath
			})
		},

		destroyed() {
			off(window, 'resize', this.onResize)
		},

		mounted: function() {
			this.$nextTick(function() {
				on(window, 'resize', this.onResize);
				
			})
		},
		created: function() {
			this.getSystemConfigList();
				
		},
        
		methods: {
			onResize() {
				clearTimeout(this.resizeTimer);
				this.resizeTimer = setTimeout(() => {
					this.height = winSize().height - 265;
				}, 200)
			},

			next() {
				if( !this.$refs['children'].verify().flag ) {//当前页的表单是否全部校验通过
					this.$message({
						message: '请先检查当前表单是否填写完成！',
						type: 'warning'
					})
					return;
				}
				var temp = this.$refs['children'].verify();
				if(temp.status == 1)
			    {
			    	this.tCloudApp.deployType = temp.form.deployType;
			    }
			    else if(temp.status == 2)
			    {
			    	this.tCloudApp.appName = temp.form.appName;
			    	this.tCloudApp.appLevel = temp.form.appLevel;
			    	this.tCloudApp.businessType = temp.form.businessType;
			    	this.tCloudAppVersion.userScope = temp.form.rangeCheck.join(",");
			    	this.tCloudAppVersion.clientType = temp.form.clientTypeArray.join(",");
			    }
			    else if(temp.status == 3)
			    {
			    	this.tCloudApp.appEnName = temp.form.appEnName;
			    	this.tCloudApp.viewName = temp.form.viewName;
			    	this.tCloudAppVersion.versionNo = temp.form.versionNo;
			    	this.tCloudAppVersion.addserviceApis = temp.form.addservicesCheck.join(",");
			    	this.tCloudAppVersion.misdataApis = temp.form.interfaceCheck.join(",");
			    	this.tCloudAppVersion.appComment = temp.form.appComment;
			    	this.tCloudAppVersion.appInstallpackagePath = temp.form.appInstallpackagePath;
			    	this.tCloudAppVersion.visitUrl = temp.form.visitUrl;
			    	this.tCloudAppVersion.packageName = temp.form.packageName;
			    }
			    else if(temp.status == 4)
			    {
			    	this.tCloudAppVersion.appVersionApplyFilePath = temp.form.paths.join(",");
			    	var s = new Array;
					for(var i = 0; i < temp.form.icolist.length; i++) {
						var icon = temp.form.icolist[i];
						s.push(icon.viewSize + "-" + icon.filePath)
					}
					this.tCloudAppVersion.appVersionIconFilePath = s.join(",");
			    }
			    else if(temp.status == 5)
			    {
			    	if(temp.form.zifei == 2)
			    	{
			    		this.tCloudApp.freeType = 2;
			    	}
			    	else{
			    		this.tCloudApp.freeType = temp.form.freeType;
			    		this.formData = JSON.stringify(temp.form.addLists);
			    	}
			    }
				this.active++;
				this.switchMethods();
			},
			save() {
				var temps = this;
				if( !this.$refs['children'].verify() ) {//当前页的表单是否全部校验通过
					this.$message({
						message: '请先检查当前表单是否填写完成！',
						type: 'warning'
					})
					return false;
				}
				var temp = this.$refs['children'].verify();
				if(temp.status == 6)
			    {
			    	this.tCloudAppVersion.publishType = temp.form.publishType;
			    	this.tCloudAppVersion.publishTime = temp.form.publishTime;
			    	this.tCloudApp.authType = temp.form.authType;
			    	this.tCloudApp.authCode = temp.form.authCode;
			    }
			    this.tCloudAppVersion.inspectStatus = 0
				var parameter = {
					"tcloudapp": this.tCloudApp,
					"tcloudappversion": this.tCloudAppVersion,
					"jsonStr": this.formData
				};
				this.$http.post('/zklccloud/saveTCloudApp', JSON.stringify(parameter), {emulateJSON: true}).then(function(data) {
					if(data.body.resultCode == '0') {
						MessageBox('操作成功', '提示', 'success', {
							confirmButtonText: '确定',
						}).then(() => {
							temps.$router.push({
								path: '/all_app'
							});
						});
					} else if(data.body.resultCode == 'exit') {
						MessageBox('应用名称已存在', '提示', 'warning', {
							confirmButtonText: '确定',
						});
						return false;
					} else {
						MessageBox('操作失败', '提示', 'error', {
							confirmButtonText: '确定',
						});
						return false;
					}
				}).catch(function() {
					MessageBox('服务器异常', '提示', 'error', {
						confirmButtonText: '确定',
					});

				});
			},
			saveTemporary()
			{
				if( !this.$refs['children'].saveverify() ) {//当前页的表单是否全部校验通过
					this.$message({
						message: '请先检查当前表单是否填写完成！',
						type: 'warning'
					})
					return false;
				}
				var temps = this;
				var temp = this.$refs['children'].saveverify();
				if(temp.status == 1)
			    {
			    	this.tCloudApp.deployType = temp.form.deployType;
			    }
			    else if(temp.status == 2)
			    {
			    	this.tCloudApp.appName = temp.form.appName;
			    	this.tCloudApp.appLevel = temp.form.appLevel;
			    	this.tCloudApp.businessType = temp.form.businessType;
			    	this.tCloudAppVersion.userScope = temp.form.rangeCheck.join(",");
			    	this.tCloudAppVersion.clientType = temp.form.clientTypeArray.join(",");
			    }
			    else if(temp.status == 3)
			    {
			    	this.tCloudApp.appEnName = temp.form.appEnName;
			    	this.tCloudApp.viewName = temp.form.viewName;
			    	this.tCloudAppVersion.versionNo = temp.form.versionNo;
			    	this.tCloudAppVersion.addserviceApis = temp.form.addservicesCheck.join(",");
			    	this.tCloudAppVersion.misdataApis = temp.form.interfaceCheck.join(",");
			    	this.tCloudAppVersion.appComment = temp.form.appComment;
			    	this.tCloudAppVersion.visitUrl = temp.form.visitUrl;
			    	this.tCloudAppVersion.appInstallpackagePath = temp.form.appInstallpackagePath;
			    	this.tCloudAppVersion.packageName = temp.form.packageName;
			    }
			    else if(temp.status == 4)
			    {
			    	this.tCloudAppVersion.appVersionApplyFilePath = temp.form.paths.join(",");
			    	var s = new Array;
					for(var i = 0; i < temp.form.icolist.length; i++) {
						var icon = temp.form.icolist[i];
						s.push(icon.viewSize + "-" + icon.filePath)
					}
					this.tCloudAppVersion.appVersionIconFilePath = s.join(",");
			    }
			    else if(temp.status == 5)
			    {
			    	if(temp.form.zifei == 2)
			    	{
			    		this.tCloudApp.freeType = 2;
			    	}
			    	else{
			    		this.tCloudApp.freeType = temp.form.freeType;
			    		this.formData = JSON.stringify(temp.form.addLists);
			    	}
			    }
				if(temp.status == 6)
			    {
			    	this.tCloudAppVersion.publishType = temp.form.publishType;
			    	this.tCloudAppVersion.publishTime = temp.form.publishTime;
			    	this.tCloudApp.authType = temp.form.authType;
			    	this.tCloudApp.authCode = temp.form.authCode;
			    }
			    this.tCloudAppVersion.inspectStatus = 9
				var parameter = {
					"tcloudapp": this.tCloudApp,
					"tcloudappversion": this.tCloudAppVersion,
					"jsonStr": this.formData
				};
				this.$http.post('/zklccloud/saveTCloudApp', JSON.stringify(parameter), {emulateJSON: true}).then(function(data) {
					if(data.body.resultCode == '0') {
						MessageBox('操作成功', '提示', 'success', {
							confirmButtonText: '确定',
						}).then(() => {
							temps.$router.push({
								path: '/all_app'
							});
						});
					} else if(data.body.resultCode == 'exit') {
						MessageBox('应用名称已存在', '提示', 'warning', {
							confirmButtonText: '确定',
						});
						return false;
					} else {
						MessageBox('操作失败', '提示', 'error', {
							confirmButtonText: '确定',
						});
						return false;
					}
				}).catch(function() {
					MessageBox('服务器异常', '提示', 'error', {
						confirmButtonText: '确定',
					});

				});
			},
			prev() {
				this.active--;
				this.switchMethods();
			},
			switchMethods() {
				switch(this.active) {
					case 0://部署类型
						this.currentView = 'vDeploy'
						break;
					case 1://基本信息
						this.currentView = 'vBase'
						break;
					case 2://扩展信息
						this.currentView = 'vExtInfo'
						break;
					case 3://图片信息
						this.currentView = 'vPhotoInfo'
						break;
					case 4://资费信息
						this.currentView = 'vExpInfo'
						break;
					case 5://发布
						this.currentView = 'vPublish'
						break;
				}
			},
			getSystemConfigList() {
				var temp = this;
				let data = {}
				this.$http.post('/zklccloud/queryAllTCloudSysDictionary', {
					emulateJSON: true
				}).then(function(m) {
					for(var key in m.body.dictionaryMap) {
						if(key == '应用分类') {
							data.appTypeOptions = m.body.dictionaryMap[key];
							if(null != temp.bussiness && '' != temp.bussiness) {
								data.businessType = temp.bussiness;
							}
						} else if(key == '群体范围') {
							data.appRange = m.body.dictionaryMap[key];
						} else if(key == '增值服务') {
							data.appAddServices = m.body.dictionaryMap[key];
						} else if(key == '数据接口权限') {
							data.appInterface = m.body.dictionaryMap[key];
						} else if(key == '部署类型') {
							data.deployType = m.body.dictionaryMap[key];
						} else if(key == '支持客户端') {
							data.clientType = m.body.dictionaryMap[key];
						}
					}
					this.datas = data;
						//查看应用信息
					this.getTCloudApp();
					this.getTCloudAppVersion();
					this.getVersionFile();
					this.getHidStatus();
					//获取价格集合
					this.getPriceList();
				})
			},
			getTCloudApp() {
				var temp = this;
				if(null == temp.appId || '' == temp.appId) {
					return false;
				}
				this.$http.post('/zklccloud/findByAppid', {
					"appId": temp.appId
				}, {
					emulateJSON: true
				}).then(function(m) {
					if(m.body.resultCode == '0') {
						temp.tCloudApp = m.body.content.tCloudApp;
					} else {
						MessageBox('查询失败！', '提示', 'error', {
							confirmButtonText: '确定',
						});
					}
				})
			},
			getTCloudAppVersion() {
				var temp = this;
				if(null == temp.appId || '' == temp.appId) {
					return false;
				}
				this.$http.post('/zklccloud/findTCloudAppVersionListById', {
					"appid": temp.appId
				}, {
					emulateJSON: true
				}).then(function(m) {
					temp.appVersionList = m.body.content.appVersionList;
					for(var i = 0; i < m.body.content.appVersionList.length; i++) {
						if(temp.appVersionId == m.body.content.appVersionList[i].id) {
							temp.tCloudAppVersion = m.body.content.appVersionList[i];
						}
					}
				})
			},
			getVersionFile() {
				var temp = this;
				if(null == temp.appId || '' == temp.appId) {
					return false;
				}
				this.$http.post('/zklccloud/findTCloudAppFilesByVersionId', {
					"appversionid": temp.appVersionId
				}, {
					emulateJSON: true
				}).then(function(m) {
					temp.appFiles = m.body.content.appFiles;
				})
			},
			getHidStatus() {
				var temp = this;
				if(null == temp.appId || '' == temp.appId) {
					return false;
				}
				this.$http.post('/zklccloud/findByVersionId', {
					"appversionId": temp.appVersionId
				}, {
					emulateJSON: true
				}).then(function(m) {
					temp.hid = m.body.content.hid;
					temp.hidsub = m.body.content.hidsub;
					temp.hidsubv = m.body.content.hidsubv;
				})
			},
			getPriceList(){
				var temp = this;
				if(null == temp.appId || '' == temp.appId || 'undefined' == temp.appId) {
					return false;
				}
				this.$http.post('/zklccloud/findPriceListByAppId', {
					"appId": temp.appId
				}, {
					emulateJSON: true
				}).then(function(m) {
					if(m.body.resultCode == '0') {
						temp.priceList = m.body.content.priceList;
					}
				})
			}
		}
	}
</script>

<style scoped>
.footer {
	padding: 12px 52px;
	border-top: 1px solid #dcdfe6;
}
.is-disabled {
	color: #CACBCD;
}
</style>

<style>
	.publish-steps .is-success {
		color: #2993FF;
		border-color: #2993FF;
	}

	.publish-steps .is-process {
		color: #354052;
		border-color: #354052;
	}

	.publish-steps .el-step__line-inner {
		display: none;
	}
</style>


// WEBPACK FOOTER //
// index.vue?07a0ed9c